const livestream = document.getElementsByClassName('livestream-embed__wrapper');
//const buttons = document.querySelectorAll(".livestream-embed__wrapper .js__embed__button");

if(livestream.length > 1) {

    
    $.each(livestream, function(i) {
        const button = document.getElementsByClassName('js__embed__button')[i];
        const lsPH = document.getElementsByClassName('livestream__placeholder')[i];
        const iframeWrap = document.getElementsByClassName('is-video-container')[i];
        const iframe = document.getElementsByClassName('video__iframe')[i];
        console.log(button);
        console.log(iframe);

        const toggleLivBtn = (function() {
            if (button.classList.contains('clicked')) {
                //button.classList.remove('is-hidden');
                button.innerHTML = "Watch Now";
                lsPH.classList.remove('is-hidden');
                iframeWrap.classList.add('is-hidden');
                iframe.removeAttribute('src', 'about:blank');
            } else {
                button.classList.add('is-hidden');
                //button.innerHTML = "Close Stream";
                lsPH.classList.add('is-hidden');
                iframeWrap.classList.remove('is-hidden');
                iframe.setAttribute('src', iframe.getAttribute('data-src'));
            }
            
        });

        if(button) {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                toggleLivBtn();
                console.log('click');
            });
        
            button.addEventListener('keypress', (e) => {
                if (e.charCode === 13) {
                    e.preventDefault();
                    toggleLivBtn();
                }
            });
        }

    });
}